<script>
	import Menu from "./Menu.svelte";
	import { onMount } from "svelte";
	import Doc from "./Doc.svelte";

	let logoapparu = false;
	onMount(async () => {
		setTimeout(() => {
			logoapparu = true;
		}, 3000);
	});
</script>

<main>
	<Menu />

	<img
		id="logo"
		class={logoapparu === true ? "logoapparu" : "logononapparu"}
		src="img/Genius.png"
		alt=""
	/>

	<div id="blocklogo">
		<img
			id="npm"
			src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Npm-logo.svg/langfr-220px-Npm-logo.svg.png"
			alt=""
		/>
		<img
			id="nodejs"
			src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/2560px-Node.js_logo.svg.png"
			alt=""
		/>
		<img
			id="svelte"
			src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Svelte_Logo.svg/498px-Svelte_Logo.svg.png?20191219133350"
			alt=""
		/>
	</div>
</main>

<style>
	@keyframes briller {
		from {
			opacity: 100%;
		}
		to {
			opacity: 30%;
		}
	}
	@keyframes apparition {
		from {
			top: -80px;
		}
		to {
			top: 80px;
		}
	}
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	.logononapparu {
		animation: apparition 2s ease-in;
	}

	.logoapparu {
		animation: briller 1.5s 4 alternate ease-in-out;
	}
	#logo {
		position: absolute;
		top: 80px;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 2;
	}
	#blocklogo {
		position: absolute;
		left: 50%;
		bottom: -20px;
		transform: translate(-50%, -50%);
		text-align: center;
	}
	#npm {
		width: 5%;
		margin: 10px;
		margin-right: 2px;
	}
	#nodejs {
		width: 5%;
		margin: 6px;
		margin-left: 1px;
		margin-right: 1px;
	}
	#svelte {
		width: 2%;
		margin: 10px;
		margin-left: 2px;
	}
</style>
